import {useMemo} from 'react';
import {IProperty} from 'modules/products/types';
import {PRODUCT_PROPERTY_CODE_ART} from 'modules/products/constants';

export const useProductIsArt = (properties?: IProperty[]) => {
    return useMemo(() => {
        const artProp = properties?.find(({code}) => PRODUCT_PROPERTY_CODE_ART === code);
        return Boolean(artProp?.value);
    }, [properties]);
};
